import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { OccOrderService, OrderActions } from '@order/data-access';
import { OrderHistoryList, normalizeHttpError } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class OnlineOrdersListEffect {
  loadHistory$: Observable<OrderActions.OnlineOrdersListActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.ORDERS_LIST_LOAD),
      map((action: OrderActions.OrdersListLoad) => action.payload),
      switchMap((payload) =>
        this.occOrderService.loadHistory(payload).pipe(
          map((orders: OrderHistoryList) => new OrderActions.OrdersListLoadSuccess(orders)),
          catchError((error: unknown) => of(new OrderActions.OrdersListLoadFail(normalizeHttpError(error)))),
        ),
      ),
    ),
  );

  loadOfflineHistory$: Observable<OrderActions.OnlineOrdersListActions> = createEffect(() =>
    this.actions$.pipe(
      ofType(OrderActions.OFFLINE_ORDERS_LIST_LOAD),
      map((action: OrderActions.OfflineOrdersListLoad) => action.payload),
      switchMap((payload) =>
        this.occOrderService.loadOfflineHistory(payload).pipe(
          map((orders: OrderHistoryList) => new OrderActions.OrdersListLoadSuccess(orders)),
          catchError((error: unknown) => of(new OrderActions.OrdersListLoadFail(normalizeHttpError(error)))),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private occOrderService: OccOrderService,
  ) {}
}
